import { WorkflowsCustomization } from '../AccountCustomization/Workflows/WorkflowsCustomization'

function AccountGovernanceWorkflows() {
  return <WorkflowsCustomization />
}

export default AccountGovernanceWorkflows
